import {
  IPassengerStationLocationResponseDto,
  MarkerIconType,
} from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export interface IPassengerAddressPin {
  locationKey: keyof IPassengerStationLocationResponseDto;
  type: MarkerIconType;
  color: string;
  badgeColor?: string;
  label?: string;
}

/**
 * The six station pins, in the exact colours and labels the Leaflet map generated them with
 * (`use-passenger-address.tsx`). Source 1 is the passenger's home; sources 2–3 and the destinations are
 * numbered, with 2 and 3 greyed as the secondary options.
 */
export const PASSENGER_ADDRESS_STATION_PINS: IPassengerAddressPin[] = [
  {
    locationKey: "sourceStation1Location",
    type: MarkerIconType.Home,
    color: rydeColors.electricPink,
  },
  {
    locationKey: "sourceStation2Location",
    type: MarkerIconType.Point,
    color: rydeColors.princetonPurple,
    label: "1",
  },
  {
    locationKey: "sourceStation3Location",
    type: MarkerIconType.Point,
    color: rydeColors.midGrey,
    label: "2",
  },
  {
    locationKey: "destinationStation1Location",
    type: MarkerIconType.DropOff,
    color: rydeColors.black,
    badgeColor: rydeColors.princetonPurple,
    label: "1",
  },
  {
    locationKey: "destinationStation2Location",
    type: MarkerIconType.DropOff,
    color: rydeColors.midGrey,
    badgeColor: rydeColors.midGrey,
    label: "2",
  },
  {
    locationKey: "destinationStation3Location",
    type: MarkerIconType.DropOff,
    color: rydeColors.midGrey,
    badgeColor: rydeColors.midGrey,
    label: "3",
  },
];
